import React from "react";
import {
  FiFileText,
  FiCheck,
  FiPackage,
  FiClock,
  FiMail,
} from "react-icons/fi";
import {
  AnalyticsGrid,
  AnalyticsCard,
  AnalyticsCardHeader,
  AnalyticsCardIcon,
  AnalyticsCardTitle,
  AnalyticsCardValue,
} from "../styles/Layoutstyle";
import { AnalyticsSkeleton } from "../skeleton/skeleton";

const Analytics = ({
  analytics,
  loading,
  onStatusFilterClick, // ← NEW: Use this for status cards
  onStreetViewFilter,
  onStatusOrderRosOnly,
  onClearFilters,
  activeView,
  isDarkMode,
}) => {
  if (loading) {
    return <AnalyticsSkeleton isDarkMode={isDarkMode} />;
  }

  return (
    <AnalyticsGrid>
      {/* Total Orders - Clear all filters */}
      <AnalyticsCard
        color="#667eea"
        onClick={onClearFilters}
        isDarkMode={isDarkMode}
      >
        <AnalyticsCardHeader>
          <AnalyticsCardIcon
            bgColor="rgba(102, 126, 234, 0.1)"
            iconColor="#667eea"
          >
            <FiFileText />
          </AnalyticsCardIcon>
          <AnalyticsCardTitle isDarkMode={isDarkMode}>
            Total Orders
          </AnalyticsCardTitle>
        </AnalyticsCardHeader>
        <AnalyticsCardValue isDarkMode={isDarkMode}>
          {analytics.totalOrders}
        </AnalyticsCardValue>
      </AnalyticsCard>

      {/* Completed Orders - Reset others and set only this status */}
      <AnalyticsCard
        color="#4caf50"
        onClick={() => onStatusFilterClick("wc-completed")}
        isDarkMode={isDarkMode}
      >
        <AnalyticsCardHeader>
          <AnalyticsCardIcon
            bgColor="rgba(76, 175, 80, 0.1)"
            iconColor="#4caf50"
          >
            <FiCheck />
          </AnalyticsCardIcon>
          <AnalyticsCardTitle isDarkMode={isDarkMode}>
            Completed Orders
          </AnalyticsCardTitle>
        </AnalyticsCardHeader>
        <AnalyticsCardValue isDarkMode={isDarkMode}>
          {analytics.completedOrders}
        </AnalyticsCardValue>
      </AnalyticsCard>

      {/* Processing Orders - Reset others and set only this status */}
      <AnalyticsCard
        color="#ff9800"
        onClick={() => onStatusFilterClick("wc-processing")}
        isDarkMode={isDarkMode}
      >
        <AnalyticsCardHeader>
          <AnalyticsCardIcon
            bgColor="rgba(255, 152, 0, 0.1)"
            iconColor="#ff9800"
          >
            <FiClock />
          </AnalyticsCardIcon>
          <AnalyticsCardTitle isDarkMode={isDarkMode}>
            Processing Orders
          </AnalyticsCardTitle>
        </AnalyticsCardHeader>
        <AnalyticsCardValue isDarkMode={isDarkMode}>
          {analytics.processingOrders}
        </AnalyticsCardValue>
      </AnalyticsCard>

      {/* EOS Orders - Reset others and set only this filter */}
      <AnalyticsCard
        color="#8cb910"
        onClick={onStatusOrderRosOnly}
        isDarkMode={isDarkMode}
      >
        <AnalyticsCardHeader>
          <AnalyticsCardIcon bgColor="#8cb91040" iconColor="#10b981">
            <FiPackage />
          </AnalyticsCardIcon>
          <AnalyticsCardTitle isDarkMode={isDarkMode}>
            Total EOS Orders
          </AnalyticsCardTitle>
        </AnalyticsCardHeader>
        <AnalyticsCardValue isDarkMode={isDarkMode}>
          {analytics.statusOrderRosCount}
        </AnalyticsCardValue>
      </AnalyticsCard>

      {/* Street View Orders - Reset others and set only this filter */}
      <AnalyticsCard
        color="#10b981"
        onClick={onStreetViewFilter}
        isDarkMode={isDarkMode}
      >
        <AnalyticsCardHeader>
          <AnalyticsCardIcon
            bgColor="rgba(16, 69, 185, 0.1)"
            iconColor="#10b981"
          >
            <FiFileText />
          </AnalyticsCardIcon>
          <AnalyticsCardTitle isDarkMode={isDarkMode}>
            Total Street View Orders
          </AnalyticsCardTitle>
        </AnalyticsCardHeader>
        <AnalyticsCardValue isDarkMode={isDarkMode}>
          {analytics.streetViewRequiredCount}
        </AnalyticsCardValue>
      </AnalyticsCard>

      {/* Pending Orders - Reset others and set only this status */}
      <AnalyticsCard
        color="#03a9f4"
        onClick={() => onStatusFilterClick("wc-pending")}
        isDarkMode={isDarkMode}
      >
        <AnalyticsCardHeader>
          <AnalyticsCardIcon
            bgColor="rgba(3, 169, 244, 0.1)"
            iconColor="#03a9f4"
          >
            <FiMail />
          </AnalyticsCardIcon>
          <AnalyticsCardTitle isDarkMode={isDarkMode}>
            Pending Orders
          </AnalyticsCardTitle>
        </AnalyticsCardHeader>
        <AnalyticsCardValue isDarkMode={isDarkMode}>
          {analytics.pendingOrders}
        </AnalyticsCardValue>
      </AnalyticsCard>
      {activeView === "analytics" && (
        <AnalyticsCard
          color="#03a9f4"
          isDarkMode={isDarkMode}
          // onClick={() => onStatusFilterClick("wc-pending")}
        >
          <AnalyticsCardHeader>
            <AnalyticsCardIcon
              bgColor="rgba(3, 169, 244, 0.1)"
              iconColor="#03a9f4"
            >
              <FiMail />
            </AnalyticsCardIcon>
            <AnalyticsCardTitle isDarkMode={isDarkMode}>
              Average Accuzip time
            </AnalyticsCardTitle>
          </AnalyticsCardHeader>
          <AnalyticsCardValue isDarkMode={isDarkMode}>
            12 min
          </AnalyticsCardValue>
        </AnalyticsCard>
      )}
    </AnalyticsGrid>
  );
};

export default Analytics;
